import { COLORS } from '~/styles/colors';

export const downloadContainer = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',

  '&.is-loading': {
    pointerEvents: 'none',
    opacity: '0.5',
  },
};

export const downloadButton = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  background: COLORS.white,
  boxShadow: '0px 0px 20px 0px #0000000D',
  padding: '18px 9px',
  borderRadius: '12px',
  border: '2px solid transparent',
  '&:hover, &.checked': {
    background: 'radial-gradient(7564.65% 631.25% at 50.09% 50%, #0487e600 0%, #0487E6 100%)',
    border: '2px solid var(--primary)',
    boxShadow: '0 0 0 1px var(--primary)',
  },
};

export const imageText = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  textTransform: 'uppercase',
};
